// 全局错误边界核心已下沉 web/shared/components/ErrorBoundary（FE1-019 注入式）：
// 下沉前本端与 admin 仅 2 行品牌口径差异（联系「平台客服」+ blue-600 按钮），
// 经 brand='business' 注入后渲染输出与本地下沉前逐字节等价；
// 壳内包装保持 '@/components/ErrorBoundary' import 路径与调用点零改动。
import type { ReactNode } from 'react';
import SharedErrorBoundary from '@shared/components/ErrorBoundary';

export default function ErrorBoundary({ children }: { children: ReactNode }) {
  return <SharedErrorBoundary brand="business">{children}</SharedErrorBoundary>;
}
